module.exports = __webpack_public_path__ + "img/ic-facebook.7c3bc28d.svg";